module.exports = __webpack_public_path__ + "img/7.b2961302.jpg";